export class Dth {
    operator:string="";
    card_number:string;
    amount:string;
}
